export default __webpack_public_path__ + "static/car_b.8a3432b4ae7e57f9831c41bbfcc1454e.svg";